import { render, staticRenderFns } from "./AllOnboardingReport.vue?vue&type=template&id=560860d6"
import script from "./AllOnboardingReport.vue?vue&type=script&lang=js"
export * from "./AllOnboardingReport.vue?vue&type=script&lang=js"
import style0 from "./AllOnboardingReport.vue?vue&type=style&index=0&id=560860d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports